/* eslint-disable no-restricted-globals */
import React from 'react';
import { RouteComponentProps } from 'react-router';
import { LoginBase } from './LoginBase';
import { Header } from './DefaultLogin';
import { SignUpForm } from './Forms/SignUpForm';
import { RouteParams } from './Forms/index.types';

export const DefaultSignUp = (props: RouteComponentProps<RouteParams, {}>) => (
  <LoginBase type="default" header={<Header />}>
    <SignUpForm
      campaign={props.location?.query?.campaign ?? 'app-sign-up'}
      registrationSuccessDestination={`${location.pathname}${location.search}${location.hash}`}
      {...props}
    />
  </LoginBase>
);
